import { StyledEngineProvider, Theme, ThemeProvider } from '@mui/material/styles';
import '@mui/styles';
import StylesProvider from '@mui/styles/StylesProvider';
import { ReactNode, useEffect } from 'react';

import { Outlet, ReactLocation, Router } from 'react-location';
import { QueryClient, QueryClientProvider } from 'react-query';
import '../design/styles/globals.scss';
import theme from '../design/themes/theme';
import LinkExpired from './components/feedback/LinkExpired';

import Feedback from './components/feedback/UIFeedback';
import Redirect from './components/Redirect';
import { Http } from './modules/prelude/http';
import Root from './pages';
import TOSPage from './pages/online';
import EntryPage2 from './pages/entry2';
import TOSLandingPage from './pages/tos';
import WaitViaSMSRedirect from './components/WaitViaSmsRedirect';
import Announcement from './components/Announcement';
import SmsFeedbackCode from './components/sms-feedback-redirect/SmsFeedbackCode';
import SmsFeedbackForm from './components/sms-feedback-redirect/SmsFeedbackForm';
import PrivacyControl from './components/PrivacyControl';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme { }
}

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme { }
}

declare module 'react-query/types/react/QueryClientProvider' {
  interface QueryClientProviderProps {
    children?: ReactNode;
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: process.env.NX_APP_STAGE === 'production',
    },
  },
});
const location = new ReactLocation();

function App(): JSX.Element {
  useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement?.removeChild(jssStyles);
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router
        location={location}
        routes={[
          {
            path: '/',
            element: <Root />,
          },
          {
            path: '/online',
            element: <TOSPage />,
          },
          {
            path: '/entry2',
            element: <EntryPage2 />,
          },
          {
            path: '/tos',
            element: <TOSLandingPage />,
          },
          {
            path: '/redirect',
            element: <WaitViaSMSRedirect />,
          },
          {
            path: '/ingress/feedback-form-code',
            element: <SmsFeedbackCode />,
            // errorElement: <LinkExpired />,
          },
          {
            path: '/ingress/feedback-form',
            element: <SmsFeedbackForm />,
            errorElement: <LinkExpired />,
          },
          {
            path: '/:link_hash',
            loader: async ({ params: { link_hash } }) => ({
              info: await Http.Request('GET', `/hotlines/api/v1/wait-via-sms/link?link=${link_hash}`),
            }),
            element: <Redirect />,
            errorElement: <LinkExpired />,
          },
        ]}
      >
        <StylesProvider injectFirst>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <div className="rhstheme">
                <PrivacyControl />
                <Announcement />
                <Feedback />
                <Outlet />
              </div>
            </ThemeProvider>
          </StyledEngineProvider>
        </StylesProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
